<pagination-template #pt="paginationApi" [id]="id" (pageChange)="pageChange.emit($event)">
    <div class="pagination-header">Showing <span *ngIf="pt.isFirstPage()">first</span> <span
            *ngIf="pt.isLastPage() && !pt.isFirstPage()">last</span> {{itemsPerPage}} results</div>
    <div class="custom-pagination">
        <span class="pagination-label">Page</span>
        <div *ngFor="let page of pt.pages" [class.current]="pt.getCurrent() === page.value">
            <a (click)="pt.setCurrent(page.value)" *ngIf="pt.getCurrent() !== page.value">
                <span>{{ page.label }}</span>
            </a>
            <div *ngIf="pt.getCurrent() === page.value">
                <span>{{ page.label }}</span>
            </div>
        </div>
    </div>
</pagination-template>